$(document).ready(function() {

    //build dropdown
    /*$("<select />").appendTo("#navigation nav");
    
    // Create default option "Go to..."
    $("<option />", {
       "selected": "selected",
       "value"   : "",
       "text"    : "Shop..."
	}).appendTo("nav select");	
	
	// Populate dropdowns with the first menu items
	$("ul#nav li a").each(function() {
	 	var el = $(this);
	 	$("<option />", {
	     	"value"   : el.attr("href"),
	    	"text"    : el.text()
	 	}).appendTo("nav select");
	});
	
	//make responsive dropdown menu actually work			
  	$("nav select").change(function() {
    	window.location = $(this).find("option:selected").val();
  	});*/

	$(".fancybox").fancybox();

  	$('.flexslider').flexslider({
    controlNav: true,
      slideshowSpeed: 6000,
	directionNav: true
  	});
    
	$('.coll-filter').customSelect();
	
   
    $('.product').hover(function(){ $(this).children('#product-info').show(); }, function(){ $(this).children('#product-info').hide(); })
 

	//<![CDATA[
	jQuery(function() {
	  jQuery('#sidebar ul li a').each(function() {
	    if (jQuery(this).attr('href')  ===  window.location.pathname) {
	      jQuery(this).addClass('current');
	    }
	  });
	});  
	//]]>
 

}); 


$(document).ready(function() {
  $(".compact .first").click(function() {
    if($(this).hasClass("active")) {
      $(".mobile-dropdown").hide();
      $(this).removeClass("active");
    } else {
      $(".mobile-dropdown").show();
      $(this).addClass("active");
    }
  });
  
  $(".list-item.dropdown a").click(function() {
    
    var $parent = $(this).parent();
    
    if($parent.hasClass("expanded")) {
      $parent.find(".list.msecondary").hide();
      $parent.removeClass("expanded");
      $parent.find("a span").html("+");
    } else {
      $parent.find(".list.msecondary").show();
      $parent.addClass("expanded");
      $parent.find("a span").html("-");
    }
  });
});

$(window).load(function() {
  $(".single-option-selector").change(function() {
    var color = $(this).val();
    
    $("#bigimage img").attr("src", $("img[data-color='" + color + "']").parent().attr("data-image"));
    $("#bigimage img").attr("data-zoom-image", $("img[data-color='" + color + "']").parent().attr("data-image"));
  });
});

$(function(){
  $(document.body).append('<div id="veil"></div>');
  $('#veil').hide();
  $('input[id=add]').click(function(e){
    e.preventDefault();
    $(this).css({
      color: '#444',
      backgroundColor: '#fff'
    }).val("Adding...");

    Shopify.addItem($('[name=id]').val(), $('#quantity').val(),function(){
        $.getJSON('/cart.js', function(data) {
            var windowH = $(window).height(),
                windowW = $(window).width(),
                modalH,
                modalW;

            $('#veil').css({height: $(document).height()}).append('<div id="addToCartModal"><h1>YOU JUST ADDED</h1><img src="'+$('#product-photos img').eq(0).attr('src')+'"><p>'+$('h1[itemprop=name]').text()+' '+$('select[name=id] option:selected').text()+'</p><span><b>'+$('#price .redprice').text()+'</b><div class="buttons"><a href="#" class="closeModal styled-submit smooth">Continue Shopping</a><a href="/cart" class="checkout styled-submit smooth">Checkout Now</a><p><span>In your <a href="/cart">cart</a>:</span>'+data.item_count+' Item'+(data.item_count != 1 ? 's' : '')+', $'+(data.total_price/100).toFixed(2)+'</p></div>');
            $('#veil').fadeIn();
            $("#addToCartModal").css({
                position:"fixed",
                left: ((windowW / 2) - ($("#addToCartModal").width() / 2)),
                top: ((windowH / 2) - $("#addToCartModal").height())
            }).fadeIn();

            $(document).keydown(function(e) {
                if (e.keyCode == 27) {
                  $('input[id=add]').css({
                      color: '#fff',
                      backgroundColor: '#2d903c'
                  }).val("Add To Cart");
                  $('#veil').fadeOut(function(){
                      $('#veil').empty();
                  });
                }
            });

            $('#veil a.closeModal').click(function(q){
                q.preventDefault();
                $('input[id=add]').css({
                    color: '#fff',
                    backgroundColor: '#2d903c'
                }).val("Add To Cart");
                $('#veil').fadeOut(function(){
                    $('#veil').empty();
                });
            });

            if ($('#cartmodal .empty').length > 0) {
                $('#cartmodal .empty').remove();
                $('#cartmodal').append('<span id="count"><b>Your Products</b> ('+data.item_count+' Items)</span><a href="/cart" class="greenbtn">Checkout</a><table><tbody></tbody></table>');
                $('#cartCount').html('Cart: ('+data.item_count+')')
            } else {
                $('#cartmodal table tbody').empty();
                $('#count').html('<b>Your Products</b> ('+data.item_count+' Items)');
                $('#cartCount').html('Cart: ('+data.item_count+')');
            }
            for (var i=0; i<data.items.length; i++){
                $('#cartmodal table tbody').append('<tr><td><img src="'+data.items[i].image+'"></td><td>'+data.items[i].title+'</td></tr>');
            }

        });
    });        
  });
});